import {BaseQueryOptions} from "@apollo/client";

export const GRID_GQL_POLL_INTERVAL = 10000

export const baseOptionsGqlGrid: BaseQueryOptions = {
  pollInterval: GRID_GQL_POLL_INTERVAL,
}
